import { create } from "zustand";
import { TInventory } from "~/types";

export type ConsolidateState = {
  step: number;
  clientId?: string;
  clientLocked: boolean;
  locationId?: string;
  selectedContainer?: TInventory;
  selectedPieces: TInventory[];
  listPieces: TInventory[];
  listContainers: TInventory[];
};

export type ConsolidateActions = {
  setStep: (step: number) => void;
  setClientId: (clientId: string) => void;
  setClientLocked: (locked: boolean) => void;
  setLocationId: (locationId?: string) => void;
  setSelectedContainer: (container: TInventory) => void;
  setSelectedPieces: (pieces: TInventory[]) => void;
  setListPieces: (pieces: TInventory[]) => void;
  setListContainers: (containers: TInventory[]) => void;

  resetState: () => void;
};

export type ConsolidateStore = ConsolidateState & ConsolidateActions;

export const useConsolidateStore = create<ConsolidateStore>((set) => ({
  step: 1,
  clientLocked: false,
  selectedPieces: [],
  listPieces: [],
  listContainers: [],
  setStep: (step: number) => set(() => ({ step })),
  setClientId: (clientId) =>
    set(() => ({
      clientId,
      selectedContainer: undefined,
      selectedPieces: [],
      listPieces: [],
      listContainers: [],
    })),
  setClientLocked: (clientLocked) => set(() => ({ clientLocked })),
  setLocationId: (locationId) => set(() => ({ locationId })),
  setSelectedContainer: (container) =>
    set(() => ({ selectedContainer: container })),
  setSelectedPieces: (pieces) => set(() => ({ selectedPieces: pieces })),
  setListPieces: (pieces) => set(() => ({ listPieces: pieces })),
  setListContainers: (containers) =>
    set(() => ({ listContainers: containers })),
  resetState: () =>
    set(() => ({
      step: 1,
      clientId: undefined,
      clientLocked: false,
      locationId: undefined,
      selectedContainer: undefined,
      selectedPieces: [],
      listPieces: [],
      listContainers: [],
    })),
}));
